import { useEffect, useState } from 'react';
import { getContentType } from '../../../Utils/helper';
import { Calculator } from '../../DueDate/CalculatorBox/styled';
import OvulationCalculatorInputs from '../../OvulationTool/OvulationCalculatorBox/OvulationCalculatorInputs';
import OvulationResults from '../../OvulationTool/OvulationResults';
import { GridWrapper } from '../../StoreHomePage/BannersGrid/styled';
import {
  CalculateHeading,
  LeftOvulationSection,
  OvulationContainer,
  OvulationContent,
  RightOvulationSection,
} from './styled';
import {
  fireClickedCTAEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default function OvulationTracker(props) {
  const { data, categoryPage } = props;

  const [count, setCount] = useState(28);
  const [resultData, setResultData] = useState({});

  useEffect(() => {
    fireServedSectionEvent(data?.heading, data?.itemId, getContentType());
  }, []);
  const startOverClickHandler = () => {
    fireClickedCTAEvent(data?.heading, 'Start over', getContentType());
    setResults(null);
    setCount(28);
  };
  return (
    <GridWrapper>
      <OvulationContainer>
        <LeftOvulationSection categoryPage={categoryPage}>
          <CalculateHeading>{data?.heading}</CalculateHeading>
          <OvulationContent>{data?.subHeading}</OvulationContent>
        </LeftOvulationSection>
        <RightOvulationSection categoryPage={categoryPage}>
          <Calculator categoryPage={categoryPage}>
            {resultData.data ? (
              <OvulationResults
                resultData={resultData.data}
                selected={resultData.selected}
                setResultData={setResultData}
                categoryPage={categoryPage}
              />
            ) : (
              <OvulationCalculatorInputs
                setResultData={setResultData}
                pregnancyPage={true}
                categoryPage={categoryPage}
              />
            )}
          </Calculator>
        </RightOvulationSection>
      </OvulationContainer>
    </GridWrapper>
  );
}
